import React, { useState } from "react";
import styles from "./IFU2.module.css";
import { DownloadIcon, EyeIcon } from "../IFU/icons/IfuIcons";

/* Both leaflets live in the HubSpot "BVC - IFUs" folder (public files).
   These CDN URLs are stable — replacing a file in HubSpot with the same
   name keeps the same URL — so no backend/API round-trip is needed:
   - View opens file 1 straight from the CDN
   - Download pulls file 2 from the CDN as a blob and saves it directly */
const VIEW_URL =
  "https://19647191.fs1.hubspotusercontent-na1.net/hubfs/19647191/BVC%20-%20IFUs/Instruction-of-use-1.pdf";
const DOWNLOAD_URL =
  "https://19647191.fs1.hubspotusercontent-na1.net/hubfs/19647191/BVC%20-%20IFUs/Instructions-of-use-2.pdf";
const DOWNLOAD_NAME = "Instructions-of-use-2.pdf";

/* Instructions for Use — download page (/IFU2)
   Hero with the leaflet intro on the left and the two PDF actions under it. */
const IFU2 = () => {
  const [downloading, setDownloading] = useState(false);

  // The CDN allows CORS, so fetch the PDF as a blob and save it — a plain
  // cross-origin anchor with `download` would open the PDF instead.
  const handleDownload = async (e) => {
    e.preventDefault();
    if (downloading) return;
    setDownloading(true);
    try {
      const res = await fetch(DOWNLOAD_URL);
      if (!res.ok) throw new Error("Download failed");
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = DOWNLOAD_NAME;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch {
      // Fallback: open the file in a new tab
      window.open(DOWNLOAD_URL, "_blank", "noopener");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <main className={styles.page}>
      <section className={styles.hero}>
        <div className={styles.copy}>
          <h1 className={styles.title}>Instructions for Use</h1>
          <p className={styles.subtitle}>
            Get official Instructions for Use for all ACUVUE® Contact Lenses
            right here.
          </p>

          <div className={styles.actions}>
            <a
              className={styles.cta}
              href={VIEW_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className={styles.ctaIcon} aria-hidden="true">
                <EyeIcon />
              </span>
              Instructions for Use
            </a>

            <a
              className={`${styles.cta} ${styles.ctaDownload}`}
              href={DOWNLOAD_URL}
              onClick={handleDownload}
              aria-busy={downloading}
            >
              <span className={styles.ctaIcon} aria-hidden="true">
                <DownloadIcon />
              </span>
              {downloading ? "Downloading…" : "Download"}
            </a>
          </div>
        </div>

        <div className={styles.visual}>
          {/* Above the fold: load eagerly, and give the browser the intrinsic
              size so the space is reserved before the image arrives — no
              layout jump on first paint. */}
          <img
            src="/Images/HydrogelLens.webp"
            alt="Contact lens shown alongside a close-up of an eye"
            width="838"
            height="865"
            fetchpriority="high"
          />
        </div>
      </section>
    </main>
  );
};

export default IFU2;
